import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'holthaus',
} as IModuleProps;
